import React from 'react';

export default function AboutHero() {
  return (
    <div className="relative pt-20 pb-16 px-6 overflow-hidden">
      {/* Decorative HUD corners */}
      <div className="absolute top-10 left-10 w-20 h-20 border-t-2 border-l-2 border-green-500/30" />
      <div className="absolute top-10 right-10 w-20 h-20 border-t-2 border-r-2 border-green-500/30" />

      <div className="max-w-7xl mx-auto flex flex-col items-center text-center">
        

        <h1 className="text-5xl md:text-7xl font-black tracking-tighter text-white mb-6 uppercase">
          Our <span className="text-green-500">Story</span>
        </h1>

        <p className="max-w-3xl text-slate-400 text-lg md:text-xl leading-relaxed font-light"
           style={{ fontFamily: '"Times New Roman", Times, serif' }}>
          SecuWall was started by experienced cybersecurity experts who have spent years protecting big companies around the world. 
          We created SecuWall with a simple goal: to bring powerful, top-level security to businesses of all sizes—so it’s strong, easy to use, and takes away your worries. 
          Our teams work across the globe to keep you safe 24/7. We never stop improving our tools, we always do the right thing, and we care most about helping our customers succeed. 
          In a world where cyber threats never rest, we’re here to give you real peace of mind.
        </p>

        {/* Scannable Data Points */}
        <div className="grid grid-cols-2 md:grid-cols-2 gap-8 mt-16 w-full max-w-2xl">
          {[
            { label: "ESTABLISHED", val: "2024" },
            { label: "HQ_LOCATION", val: "DHAKA | BANGLADESH" },
        
          ].map((stat, i) => (
            <div key={i} className="flex flex-col border-l border-white/10 pl-4 text-left">
              <span className="text-[12px] font-mono text-green-600 tracking-widest">{stat.label}</span>
              <span className="text-2xl font-bold text-white tracking-tight">{stat.val}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}